import {LayoutModule} from '@/store/modules/LayoutModule';

// tslint:disable-next-line:ban-types
function process(func: Function, title: string, description: string | Function, cancelFunction: Function) {
  function processed(...args: any) {
    LayoutModule.showConfirmDialog({
      title,
      // @ts-ignore
      // tslint:disable-next-line:ban-types
      description: (typeof description === 'string') ? description : (description as Function)(this),
      // @ts-ignore
      action: () => func.apply(this, args),
      // @ts-ignore
      cancelAction: () => cancelFunction(this)
    });
  }

  return processed;
}

// tslint:disable-next-line:ban-types no-empty
export function Confirm(title: string, description: string | Function, cancelFunction: Function = () => {
}) {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    // tslint:disable-next-line:ban-types
    const originalValue: Function = descriptor.value;

    descriptor.value = process(originalValue, title, description, cancelFunction);
    return descriptor;
  };
}
